import { GetOptionValue, GroupBase } from 'react-select';

import { InputSelect, type InputSelectProps } from '@/design_system/InputSelect/InputSelect';

export const InputSearchSelect = <
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(
  props: InputSelectProps<Option, IsMulti, Group> & { getOptionValue: GetOptionValue<Option> }
) => {
  return <InputSelect {...props} isClearable />;
};
